import { createContext, useContext } from 'react';

export interface IVehicleContextProps {
    olderCar: boolean;
    carNotInList: boolean;
    tariffGroup: number | undefined;
    vehicleName: string | undefined;
    isLeasingCar: boolean | undefined;
    trackingUnit: boolean | undefined;
    trackingUnitShown: boolean | undefined;
    validLeasing: boolean;
    presentLeasing: boolean;
    carCanProceed: boolean;
    manufacturerExcluded: boolean;
    noContent3738: boolean;
    vin?: string | null;
    partner?: string | null;
    setTrackingUnit: Function;
    setTrackingUnitShown: Function;
    setNoContent3738: Function;
}

const VehicleContext = createContext<IVehicleContextProps>({} as IVehicleContextProps);
export { VehicleContext };
export const useVehicleContext = () => useContext(VehicleContext);
